import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError, IClientApiDependencySegment } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { AdjustmentProfileAction } from '../adjustmentProfile.action';
import { AdjustmentProfileTranslator } from '../adjustmentProfile.translator';

export const loadAdjustmentListEpic: IEpic<{}, IClientApiDependencySegment> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(AdjustmentProfileAction.loadList.started),
  mergeMap(() => dependencies.api.getAdjustmentProfileList().pipe(
    mergeMap((response) => {
      const data = response.profiles
        .map(AdjustmentProfileTranslator.fromApi)
        .reduce((acc, item) => ({ ...acc, [item.adjustmentId]: item }), {});
      const result = {
        data,
        defaultData: AdjustmentProfileTranslator.defaultFromApi(response.default),
      };

      return [AdjustmentProfileAction.loadList.done({ result })];
    }),
    catchApiError((error) => {
      return [
        AdjustmentProfileAction.loadList.failed({ error: null }),
        createApiErrorNotification(error),
      ];
    }),
  )),
);
